import { haveValue } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import ProfileRow from "./ProfileRow";

const ProfileTable = ({
  profile,
  properties,
  loadData,
  user,
  openAssignLLModal,
  checkSalary,
  rentPercentage,
  rentDoc,
  tenantChecks = false,
}) => {
  const { _t } = useTranslator();

  return (
    <>
      <div className="upcoming-box ">
        <table className="upcoming-table landlord-table bigtable_set">
          <thead className="hideOnMobile">
            <tr className="first-row">
              <th style={{ width: "25%" }}> {_t("tenant")} </th>
              <th> {_t("score", "Field in profile table")} </th>
              <th> {_t("effortRate", "Field in profile table")} </th>
              <th> {_t("guarantors")} </th>
              <th> {_t("linkedProperties", "Field in profile table")} </th>
              {/* {user?.isParentLL && !tenantChecks && (
                <th>
                  {" "}
                  {_t(
                    "assignAgent/Landlord",
                    "Field located in the agency-side profile table"
                  )}{" "}
                </th>
              )} */}
              {/* <th> {_t("profileCompletion", "Field in profile table")} </th> */}
              <th style={{ width: "16%" }}>
                {" "}
                {_t("infoUpdatedAt", "Field in profile table")}{" "}
              </th>
              <th style={{ width: "2%" }}></th>
            </tr>
          </thead>

          <tbody>
            {haveValue(profile)
              ? profile.map((data) => (
                  <ProfileRow
                    profile={data}
                    properties={properties}
                    loadData={loadData}
                    openAssignLLModal={openAssignLLModal}
                    checkSalary={checkSalary}
                    rentPercentage={rentPercentage}
                    rentDoc={rentDoc}
                    tenantChecks={tenantChecks}
                  />
                ))
              : _t("noDetailsFound")}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ProfileTable;
